import { createRouter } from '@tanstack/react-router';
import type { AuthContextProps } from 'react-oidc-context';
import { queryClient } from '@/core/query/client';
import { routeTree } from '@/routeTree.gen';

export interface RouterContext {
  queryClient: typeof queryClient;
  auth: AuthContextProps;
}

export const router = createRouter({
  routeTree,
  // `auth` é injetado pelo <RouterProvider> em App.tsx.
  context: { queryClient, auth: undefined! },
  defaultPreload: 'intent',
  // O TanStack Query já cuida do cache; o loader não deve guardar cópia.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  /** Metadados que as rotas declaram para o layout. */
  interface StaticDataRouteOption {
    /** Abre com a barra lateral recolhida (só ícones) — telas que precisam de largura, como o player. */
    compactNav?: boolean;
  }
}
